export const GET_DEFAULT_SUBSCRIPTION = "GET_DEFAULT_SUBSCRIPTION"
export const SAVE_DEFAULT_SUBSCRIPTION = "SAVE_DEFAULT_SUBSCRIPTION"